import styled from 'styled-components'
import { themeFontWeight, themeColor } from '@elparking/components'

const darkMainColor = props => props.theme.colors.darkMain || 'red'
const mainColor = props => props.theme.colors.main || 'red'
const lightGray20 = props => props.theme.colors.lightGray40 || 'red'
const white = props => props.theme.colors.white || 'red'

export const ParkingCardParkingTypeLegend = styled.div`
    background: ${darkMainColor};
    color: ${white};
    text-transform: uppercase;
    font-size: 12px;
    padding: 0.3em 1em;
    display: inline-block;
    font-weight: ${themeFontWeight('book')};
    line-height: normal;
    margin-right: 0.5em;
    align-items: center;
    align-content: center;
`

export const ParkingCardParkingTypeLegendOfficial = styled(ParkingCardParkingTypeLegend)`
    background: ${lightGray20};
    color: ${mainColor};
    text-transform: none;
`

export const ParkingCardParkingTypeLegendMowizTruck = styled(ParkingCardParkingTypeLegend)`
    background: transparent;
    color: ${themeColor('gray')};
    text-transform: none;
    border: 1px solid ${themeColor('gray20')};
`
